// reducers
const defaultFlags = require('../../initFlags/featureFlags').flags;

function flags(state = defaultFlags, action) {
  switch (action.type) {
    case 'FLAGS_INIT_SUCCESS':
      return action.flags;

    default:
      return state;
  }
}

export default flags;
